import * as React from 'react'
import CmsRouter from "../control/CmsRouter";

export default <CmsRouter initialLocation={window.location.href} />


